.Pillar {
  color: var(--brand-color-text-default);
  display: flex;
  flex-direction: column;
}

.Pillar--has-max-width {
  max-width: 50ch;
}

.Pillar--has-border {
  border: var(--brand-borderWidth-thin) solid var(--brand-color-border-default);
  border-radius: var(--brand-borderRadius-medium);
  padding: var(--base-size-32);
}

.Pillar.Pillar--align-center {
  align-items: center;
  text-align: center;
}

.Pillar.Pillar--align-start {
  align-items: flex-start;
  text-align: left;
}

.Pillar__image {
  margin-bottom: var(--base-size-28);
  border-radius: var(--brand-borderRadius-medium);
  overflow: hidden;
}

.Pillar__image img,
.Pillar__image span,
.Pillar__image picture {
  display: block;
}

.Pillar__icon {
  margin-bottom: var(--base-size-48);
}

.Pillar__icon--with-background {
  border-radius: var(--base-size-12);
}

.Pillar__icon--with-background > svg {
  width: 100%;
  height: 100%;
}

.Pillar__heading {
  margin-bottom: var(--base-size-16);
}

.Pillar__description:not(.Pillar--has-border .Pillar__description:last-child) {
  margin-bottom: var(--base-size-24);
}

.Pillar__link {
  margin-top: auto;
}
